import * as React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Navbar from "./components/NavBar.js";
import SideBar from "./components/SideBar.js";
import Footer from "./components/Footer.js";
import "./App.css";
import Home from './pages/Home';
//import Layout from './pages/Layout';

import Test from './pages/Test';
import Grammar from './pages/Grammar';
import GrammarIntroducion from './pages/GrammarIntroducion';
import GrammarAlfabeto from './pages/GrammarAlfabeto';
import GrammarArticulos from './pages/GrammarArticulos';
import GrammarAdjetivos from './pages/GrammarAdjetivos';
import GrammarNumerales from './pages/GrammarNumerales';
import GrammarPronombres from './pages/GrammarPronombres';
import GrammarAdverbios from './pages/GrammarAdverbios';
import GrammarPreposiciones from './pages/GrammarPreposiciones';
import GrammarIndicativo from './pages/GrammarIndicativo';
import GrammarSubjuntivo from './pages/GrammarSubjuntivo';
import GrammarCondicional from './pages/GrammarCondicional';
import GrammarImperativo from './pages/GrammarImperativo';
import GrammarPerifrasis from './pages/GrammarPerifrasis';
import GrammarSerestarhaber from './pages/GrammarSerestarhaber';
import GrammarCondicionales from './pages/GrammarCondicionales';
import GrammarIndirecto from './pages/GrammarIndirecto';
import GrammarPasiva from './pages/GrammarPasiva';
import GrammarTemporales from './pages/GrammarTemporales';
import Idiom from './pages/Idiom.js';
import Phrase from './pages/Phrase';
import Lang from './pages/Lang';
import Dictionary from './pages/Dictionary';
import Verb from './pages/Verb';
import Proverb from './pages/Proverb';
import Template from './pages/Template';
import Www from './pages/Www';
import Book from './pages/Book';
import Music from './pages/Music';
import Poetry from './pages/Poetry';
import About from './pages/About';
import Sitemap from './pages/Sitemap.js';

import styled from "styled-components";

const Main = styled.div`
  display: flex;
  flex: 1;
//  background-color: #00FF00;
`;

const Content = styled.div`
  padding: 5px;
  display: flex;
  flex: 1;
//  background-color: #0000CC;
`;

export default function App() {
  return (
	  <Router>
      <Navbar />
      <Main>
        <SideBar />
        <Content>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/test" element={<Test />} />
            <Route path="/test/:id" element={<Test />} />
            <Route exact path="/grammar" element={<Grammar />} />
            <Route path="/grammar/introducion" element={<GrammarIntroducion />} />
            <Route path="/grammar/alfabeto" element={<GrammarAlfabeto />} />
            <Route path="/grammar/articulos" element={<GrammarArticulos />} />
            <Route path="/grammar/adjetivos" element={<GrammarAdjetivos />} />
            <Route path="/grammar/numerales" element={<GrammarNumerales />} />
            <Route path="/grammar/pronombres" element={<GrammarPronombres />} />
            <Route path="/grammar/adverbios" element={<GrammarAdverbios />} />
            <Route path="/grammar/preposiciones" element={<GrammarPreposiciones />} />
            <Route path="/grammar/indicativo" element={<GrammarIndicativo />} />
            <Route path="/grammar/subjuntivo" element={<GrammarSubjuntivo />} />
            <Route path="/grammar/condicional" element={<GrammarCondicional />} />
            <Route path="/grammar/imperativo" element={<GrammarImperativo />} />
            <Route path="/grammar/perifrasis" element={<GrammarPerifrasis />} />
            <Route path="/grammar/serestarhaber" element={<GrammarSerestarhaber />} />
            <Route path="/grammar/condicionales" element={<GrammarCondicionales />} />
            <Route path="/grammar/indirecto" element={<GrammarIndirecto />} />
            <Route path="/grammar/pasiva" element={<GrammarPasiva />} />
            <Route path="/grammar/temporales" element={<GrammarTemporales/>} />
            <Route path="/idiom" element={<Idiom />} />
            <Route path="/phrase" element={<Phrase />} />
            <Route path="/lang" element={<Lang />} />
            <Route path="/dictionary" element={<Dictionary />} />
            <Route path="/verb" element={<Verb />} />
            <Route path="/proverb" element={<Proverb />} />
            <Route path="/template" element={<Template />} />
            <Route path="/www" element={<Www />} />
            <Route path="/book" element={<Book />} />
            <Route path="/music" element={<Music />} />
            <Route path="/poetry" element={<Poetry />} />
            <Route path="/poetry/:entryId" element={<Poetry />} />
            <Route path="/about" element={<About />} />
            <Route path="/sitemap" element={<Sitemap />} />
          </Routes>
        </Content>
      </Main>
      <Footer />
    </Router>
  );
}